/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shipping_Address_UnsupportedInputs */

const vi_error_shipping_address_unsupported = /** @type {(inputs: Error_Shipping_Address_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viettel Post chưa hỗ trợ địa chỉ phường/xã này; nhân viên sẽ báo phí ship sau.`)
};

/**

* @param {Error_Shipping_Address_UnsupportedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shipping_address_unsupported = /** @type {((inputs?: Error_Shipping_Address_UnsupportedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shipping_Address_UnsupportedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shipping_address_unsupported(inputs)
});